import { getInvoices } from "@/services/invoices.service";
import { useQuery } from "@tanstack/react-query";

export const useInvoices = (
  enabled = true,
  params = { page: 0, size: 10 },
  options = {},
) => {
  const queryKey = [
    "invoices",
    params.page,
    params.size,
    params.status,
    params.search,
  ];

  return useQuery({
    queryKey,
    queryFn: () => getInvoices(params),
    enabled,
    ...options,
  });
};
